import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-deepak-das',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './deepak-das.html',
  styleUrl: './deepak-das.css',
})
export class DeepakDas {}
